(ns dre.pages.frontpage.topic-search.views.topic-forms
  (:require [clj-commons.humanize :refer [intcomma]]
            [clj-commons.humanize.inflect :refer [pluralize-noun]]
            [dre.app.router :as router :refer [->route]]
            [dre.components.loading-spinner :refer [loading-spinner]]
            [dre.components.radio-group :refer [radio-group]]
            [dre.pages.frontpage.topic-search.events :as events]
            [dre.components.icons-iconoir :refer [icoinor-icon]]
            [dre.pages.frontpage.topic-search.views.topic-form :as form]
            [dre.i18n.views :refer [tr]]
            [dre.shared.interface.search.util :refer [normalized-blunt-new]]
            [dre.utils.bem :as bem]
            [dre.utils.query :as query]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def component-name :topic-search-forms)

(defmulti forms :forms-type)

(defn render-item
  [pills title divider]
  (if (not (seq pills))
    [:span.highlight "[" title "]"]
    (map-indexed (fn [idx ele]
                   ^{:key idx} [:<> [:span.highlight (events/get-pill-label ele)] (if (< (inc idx) (count pills)) divider " ")]) pills)))

(defmethod forms :common
  [props show-error-msg?]
  (let [form-filled? @(rf/subscribe [::events/is-form-filled? (:topic-name props) (map #(:form-id %) (:forms props))])
        some-filled? @(rf/subscribe [::events/is-some-form-filled? (:topic-name props) (map #(:form-id %) (:forms props))])
        required-filled? @(rf/subscribe [::events/is-some-form-filled? (:topic-name props) (map #(:form-id %) (filter #(:required? %) (:forms props)))])

        terms-counts @(rf/subscribe [::events/get-terms-count (:topic-name props)])
        blunt @(rf/subscribe [::events/get-search-query-blunt (:topic-name props)])
        selected-search-query-template-type  (or
                                              @(rf/subscribe [::events/get-selected-search-query-template-type (:topic-name props)])
                                              (:default-search-query-template props))
        search-query-template-types (keys (:search-query-templates props))

        qp {:query blunt :type (str "articles") :viewtype (name (:topic-name props))}

        items-to-display (into {} (map (fn [e]
                                         {(:form-id e) (render-item
                                                        @(rf/subscribe [::events/get-form-pills (:topic-name props) (:form-id e)]) (:title e) "/")})
                                       (:forms props)))
        items-with-operator (into {} (map (fn [e]
                                            {(:form-id e) (render-item
                                                           @(rf/subscribe [::events/get-form-pills (:topic-name props) (:form-id e)])
                                                           (:title e)
                                                           (str " " (name (or @(rf/subscribe [::events/get-form-operator (:topic-name props) (:form-id e)]) (:operator e))) " "))})
                                          (:forms props)))
        review-query ((:review-query-render-fn props) items-to-display selected-search-query-template-type)
        send-query ((:review-query-render-fn props) items-with-operator selected-search-query-template-type)
        enabled? (and (and some-filled? required-filled?) (not (empty? terms-counts))) ]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :title)}
      [:<>
       [:span.strong-text (:title props)]
       [:div
        {:class (bem/be component-name :sub-heading)}
        (:form-sub-heading props)]]] 
     (when (> (count search-query-template-types) 1)
       [:div
        {:class (bem/be component-name :templates-selection)}
        [radio-group
         {:on-change (fn [e]
                       (rf/dispatch [::events/set-selected-search-query-template-type (:topic-name props) (:value e)]))
          :checked selected-search-query-template-type
          :options (map #(hash-map :id %) search-query-template-types)}]])
     [:div
      {:class (bem/be component-name :form-wrapper)}
      (for [[idx f] (map-indexed vector (:forms props))]
        ^{:key idx}
        [form/view idx f])]
     [:div
      {:class (bem/be component-name :preview-wrapper)}
      [:div.text
       {:id :topic-search-question}
       review-query]
      [:div
       {:style {:display "none"
                :visibility "hidden"}
        :id :topic-search-question-operator}
       send-query]]
     (when some-filled?
       [:div
        {:class (bem/be component-name :terms-count)}
        (if (empty? terms-counts)
          [loading-spinner]
          [:<>
           [:span "About "]
           [:span.strong (intcomma (:search/count terms-counts))]
           [:span " "]
           [:span (pluralize-noun (:search/count terms-counts) "result")]
           [:span " ("]
           [:span.strong (intcomma (:search/count-6m terms-counts))]
           [:span " in the past "]
           [:span.strong "6"]
           [:span " months, "]
           [:span.strong (intcomma (:search/count-1w terms-counts))]
           [:span " in the past week)"]])])
     [:div
      {:class (bem/be component-name :footer)}
      (when @show-error-msg?
        [:div
         {:class (bem/be component-name :error-msg)}
         [tr "Please fill out the required field(s)"]])
        [:div
         {:class (bem/be component-name :footer-controls)}
         [:button.button.previous
          {:on-click #(rf/dispatch [::events/select-view :topics])}
          [icoinor-icon :nav-arrow-left {:width ".25em" :height ".35em" :strokeWidth 1.0}]
          "Previous"]
         [:button.button.next
          {:class (when enabled?  "enabled")
           ;; :disabled (or (not (and some-filled? required-filled?)) (empty? terms-counts)) 
           :on-click (if (or (not (and some-filled? required-filled?)) (empty? terms-counts))
                       #(reset! show-error-msg? true)
                       #(let [question (-> (js/document.getElementById "topic-search-question-operator") .-innerText)]
                          (reset! show-error-msg? false)
                          (rf/dispatch [::router/redirect-to-path-with-query-params (->route :search) (merge
                                                                                                       (assoc qp :question question
                                                                                                              :baq-topic (name (:topic-name props))
                                                                                                              :baq-starttime (.toISOString (js/Date.)))
                                                                                                       (into (hash-map) (for [[idx f] (map-indexed vector (:forms props))]
                                                                                                                          [(str "baq-category-" (inc idx) "-type")
                                                                                                                           (name (:form-id f))]))
                                                                                                       (into (hash-map) (for [[idx f] (map-indexed vector (:forms props))]
                                                                                                                          [(str "baq-category-" (inc idx) "-blunt")
                                                                                                                           (normalized-blunt-new
                                                                                                                            {:query/pills
                                                                                                                             @(rf/subscribe [::events/get-form-pills (:topic-name props) (:form-id f)])})])))])))}
        
          "View Results"
          [icoinor-icon :nav-arrow-right (merge {:width ".25em" :height ".35em" :strokeWidth 1.0}
                                                (when enabled? {:color "white"}))]]]]]))

(defn view
  []
  (let [show-error-msg? (r/atom false)]
    (fn [] (let [topic-name @(rf/subscribe [::events/selected-topic])
                 topic (get events/topics-map topic-name)]
             [forms (assoc topic :topic-name topic-name) show-error-msg?]))))

